// extracted by mini-css-extract-plugin
var _1 = "DashboardTile-modulechart__X0c6Z";
var _2 = "DashboardTile-moduledetails__J_VpB";
var _3 = "DashboardTile-moduleinteractive__bTW0H";
var _4 = "DashboardTile-modulelabel__SBUQl";
var _5 = "DashboardTile-moduletile__tbEPQ";
var _6 = "DashboardTile-modulevalue__H2Mrw";
export { _1 as "chart", _2 as "details", _3 as "interactive", _4 as "label", _5 as "tile", _6 as "value" }
